export default __webpack_public_path__ + "img/777593b7d1930f91344f324fb98f27ee.jpg";